export default "/images/Logo-Thick-Gold.svg?68b5b5fca8fe14c1fafcbed56cd5c747";